var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "save") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.17 5.735l-4.655-4.655c-0.202-0.204-0.483-0.33-0.792-0.33-0.001 0-0.002 0-0.003 0h-14.095c-0.621 0.001-1.124 0.504-1.125 1.125v20.25c0.001 0.621 0.504 1.124 1.125 1.125h18.75c0.621-0.001 1.124-0.504 1.125-1.125v-15.595c0-0.001 0-0.002 0-0.003 0-0.31-0.126-0.59-0.329-0.792l-0-0zM15 2.25v4.5h-6.75v-4.5zM21 21.75h-18v-19.5h3.75v6h9.75v-6h0.064l4.436 4.436z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.813 10.5c-2.382 0-4.313 1.931-4.313 4.313s1.931 4.313 4.313 4.313c2.382 0 4.313-1.931 4.313-4.313v0c-0.003-2.381-1.932-4.31-4.312-4.313h-0zM11.813 17.625c-1.553 0-2.813-1.259-2.813-2.813s1.259-2.813 2.813-2.813c1.553 0 2.813 1.259 2.813 2.813v0c-0.002 1.553-1.26 2.811-2.812 2.813h-0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.a263a7a64a271b0cf1d32cba4a4d57cf.svg";
export { ForwardRef as ReactComponent };